module.exports = __webpack_public_path__ + "img/board-black.de071547.svg";